import React, { Component } from "react";
// import { withRouter, useLocation } from "react-router-dom";
import { withRouter } from "react-router-dom";
//
import qs from "qs";

import * as requests from "../../../helpers/requests";
import config from "../../../config";

import "./style.css";
import { Input } from "antd";

import Header from "./header";

function useQuery() {
  // return new URLSearchParams(useLocation().search);
  return "";
}

class TrainingSurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      email: null,
      email_id: null,
      checked: false,
    };
    this.email_id = null;
  }

  componentDidMount() {
    let query = qs.parse(this.props.location.search.slice(1));
    this.email_id = query.id;
    this.setState({ email_id: this.email_id });
    // console.log("email id is", this.email_id);
    document.title = "Safety Symposium Questions";

    // requests.post(url, JSON.stringify(body));
  }

  confirm = (e) => {
    // e.preventDefault();
    if (
      this.state.q1 &&
      this.state.q2 &&
      this.state.q3 &&
      this.state.q4 &&
      this.state.q5 &&
      // this.state.q6 &&
      // this.state.q7 &&
      // this.state.q8 &&
      // this.state.q9 &&
      // this.state.q10 &&
      // this.state.q11 &&
      this.state.email &&
      this.state.checked
    ) {
      e.preventDefault();
      let url = `${config.api_url}/webapi/v1/backcountry_yyc_survey_response/`;
      let body = {
        email_id: this.email_id,
        email: this.state.email,
        questions: [
          { key: "q1", answer: this.state.q1 },
          { key: "q2", answer: this.state.q2 },
          { key: "q3", answer: this.state.q3 },
          { key: "q4", answer: this.state.q4 },
          { key: "q5", answer: this.state.q5 },
          // { key: "q6", answer: this.state.q6 },
          // { key: "q7", answer: this.state.q7 },
          // { key: "q8", answer: this.state.q8 },
          // { key: "q9", answer: this.state.q9 },
          // { key: "q10", answer: this.state.q10 },
          // { key: "q11", answer: this.state.q11 },
        ],
      };
      requests
        .post(url, JSON.stringify(body))
        .catch((err) => console.log(err))
        .then(
          (res) =>
            (window.location = `https://platform.ascensionapp.com/backcountry_thanks`)
        );
    }
    // e.preventDefault();
    // console.log(e);
    // window.location = "https://www.howtoclimb513.com";
  };

  keydown = () => {};

  render() {
    let row_count = 5;
    // let query = qs.parse(this.props.location.search.slice(1));
    // console.log(query.id);
    return (
      <div className="wrapper">
        <div className="bcyyc-flex">
          <Header />
          <div className="label margin20 t-align-c">
            Safety Symposium Questions
          </div>
          <form action="">
            <div className="main">
              {this.email_id ? null : (
                <div className="width-100">
                  <div className="input-wrap t-align-l">
                    <p className="label2 t-align-l margin-b-0">
                      What's your email?
                    </p>
                    <input
                      name="email"
                      type={"email"}
                      id="input-survey-email"
                      className="input-survey-email"
                      required
                      maxlength={256}
                      ref={(inp) => {
                        this._input = inp;
                      }}
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      onKeyDown={this.keydown}
                    />
                  </div>
                </div>
              )}
              {[
                {
                  title:
                    "How much experience do you have in the backcountry? Years, days a year, etc.",
                  value: this.state.q1,
                  key: "q1",
                },
                {
                  title: "What kind of back country training do you have?",
                  value: this.state.q2,
                  key: "q2",
                },
                {
                  title:
                    "If you could ask a guide, a pro-skier, and a forecaster anything.  What would those questions be?",
                  value: this.state.q3,
                  key: "q3",
                },
                {
                  title:
                    "Do you do any physical training for your time in the backcountry?",
                  value: this.state.q4,
                  key: "q4",
                },
                {
                  title:
                    "Have any injuries kept you from riding?  Or from going out?",
                  value: this.state.q5,
                  key: "q5",
                },
              ].map((question) => {
                return (
                  <div>
                    <div className="input-wrap">
                      <p className="">{question.title}</p>
                      <textarea
                        rows={row_count}
                        type={"text"}
                        multiline
                        className="input-survey"
                        name={this.props.name}
                        required
                        maxlength={2048}
                        ref={(inp) => {
                          this._input = inp;
                        }}
                        value={question.value}
                        placeholder={""}
                        onChange={(e) =>
                          this.setState({ [question.key]: e.target.value })
                        }
                        onKeyDown={this.keydown}
                      />
                    </div>
                  </div>
                );
              })}

              {this.state.checked ? null : (
                <div className="input-wrap-flex">
                  <div className="checkbox">
                    <Input
                      required
                      checked={this.state.checked}
                      style={{ paddingTop: 0, paddingBottom: 0, height: 20 }}
                      className="flex"
                      type="checkbox"
                      aria-label="Checkbox for following text input"
                      onChange={(e) => {
                        this.setState({ checked: !this.state.checked });
                      }}
                    />
                  </div>
                  <div
                    className="auto"
                    onClick={() =>
                      this.setState({ checked: !this.state.checked })
                    }
                  >
                    <div className="noflex">
                      <div>
                        Check if you are okay with us following up on this
                        survey.
                      </div>
                      <div style={{ fontSize: 8 }}>
                        We will not to sell your email to Russian spam lists
                        (and not sell it/provide it to any other parties
                        otherwise)
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="button-wrap">
                <button className="bcyyc-button" onClick={this.confirm}>
                  SEND IT!
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(TrainingSurvey);
